(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    countdown = (elem, datetime) => {
  if (!elem) return;  
  let date = new Date(datetime).getTime(),
      interval = setInterval(() => {
        let now = new Date().getTime(),
            distance = date - now,
            days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000)
        now = new Date(now).toUTCString()
        now = new Date(now).getTime()
        elem.innerHTML = `
          <div class="countdown__item countdown__item--days">
            <div class="countdown__numeral">${(days < 10) ? '0' + days : days.toString()}</div>
            <div class="countdown__label">Days</div>
          </div>
          <div class="countdown__item countdown__item--hours">
            <div class="countdown__numeral">${(hours < 10) ? '0' + hours : hours.toString()}</div>
            <div class="countdown__label">Hours</div>
          </div>
          <div class="countdown__item countdown__item--minutes">
            <div class="countdown__numeral">${(minutes < 10) ? '0' + minutes : minutes.toString()}</div>
            <div class="countdown__label">Mins</div>
          </div>
          <div class="countdown__item countdown__item--seconds">
            <div class="countdown__numeral">${(seconds < 10) ? '0' + seconds : seconds.toString()}</div>
            <div class="countdown__label">Secs</div>
          </div>
        `
        if (distance < 0) {
          clearInterval(interval)
          elem.innerHTML = ``
        }
      }, 1000)
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-menu__list-item').forEach(item => {
  const link = item.querySelector('.nav-menu__list-link[aria-haspopup="true"]');
  if (!link) return;
  let touchedOnce = false;
  const openMenu = () => link.setAttribute('aria-expanded', 'true');
  const closeMenu = () => {
    link.setAttribute('aria-expanded', 'false');
    touchedOnce = false;
  };
  link.addEventListener('touchstart', e => {
    if (!touchedOnce) {
      e.preventDefault();
      link.focus();
      touchedOnce = true;
      openMenu();
    } else {
      window.location.href = link.getAttribute('href');
    }
  });
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('touchstart', openMenu);
  item.addEventListener('mouseleave', closeMenu);
  document.addEventListener('touchstart', e => {
    if (!item.contains(e.target)) closeMenu();
  });
});
  } catch(e) { console.error(e); }
})();

})();
